import { ResourceManager } from "@/components/ResourceManager";
import { FileText } from "lucide-react";

const fields = [
  { name: "title", label: "Title", type: "text", required: true },
  { name: "category", label: "Category", type: "select", options: ["Registration", "12A / 80G", "Annual Report", "Financial Report", "Project Report", "Policy", "Certificate", "Other"] },
  { name: "description", label: "Description", type: "textarea", table: false },
  { name: "file_path", label: "File", type: "file" },
];

export default function DocumentsAdmin() {
  return <ResourceManager title="Transparency Documents" eyebrow="Content" endpoint="documents" fields={fields} hasPublish icon={FileText} />;
}
